@if (communityStatus === 'offline') {
    <div class="community-banner-wrapper">
        <div class="alert-card" (click)="toggleBanner()">
            <div class="alert-content">
                <i class="fa-solid fa-triangle-exclamation alert-icon"></i>
                <div class="alert-text">
                    <p class="alert-title">🚨 {{ 'COMMUNITY.offline-title' | transloco }}</p>
                    @if (expanded) {
                        <p class="alert-desc">{{ 'COMMUNITY.offline-desc' | transloco }}</p>
                    } @else {
                        <p class="alert-hint">{{ 'COMMUNITY.offline-hint' | transloco }}</p>
                    }
                </div>
            </div>
        </div>
    </div>
}
